import { Base, BaseProps, Flex, Notification } from '@bitrise/bitkit';
import { CrashStackTraceFrame as TypeCrashStackTraceFrame, SupportedPlatforms } from '@trace/types';
import classnames from 'classnames';
import React, { FunctionComponent } from 'react';
import CrashStackTraceFrame from './CrashStackTraceFrame';
import './CrashStackTrace.css';

export interface Props extends BaseProps {
  isCrash?: boolean;
  platform: SupportedPlatforms;
  stacktrace: TypeCrashStackTraceFrame[];
}

const CrashStackTrace: FunctionComponent<Props> = ({ isCrash, platform, stacktrace, ...rest }) => {
  const classes = classnames('CrashStackTrace', {
    'CrashStackTrace--is-crash': isCrash,
    'CrashStackTrace--has-frames': stacktrace.length > 0,
  });

  return (
    <Flex {...rest} className={classes}>
      {stacktrace.length > 0 ? (
        <Flex className="CrashStackTrace__frame-list" direction="vertical">
          {stacktrace.map((frame, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <CrashStackTraceFrame {...frame} key={index} platform={platform} />
          ))}
        </Flex>
      ) : (
        <Base paddingHorizontal={isCrash ? 'x8' : undefined}>
          <Notification icon="BitbotFailed" type="alert" width="auto">
            Sorry, we were unable to capture a stacktrace.
          </Notification>
        </Base>
      )}
    </Flex>
  );
};

export default CrashStackTrace;
